<template>
    <c-dialog ref="dialog" width="500" :height="withdraw_time_disabled ? 400 : 350"
              :class="{'z-time-disabled': withdraw_time_disabled}" @resolve="editHandle">
        <c-form ref="form" vertical unit-width="100%">
            <p class="m-withdraw-time-tip" v-if="withdraw_time_disabled">{{withdraw_time_tip}}</p>
            <c-form-item :label="false">
                <c-select name="bank_card_id" async :disabled="withdraw_time_disabled" @search="searchBankCard">
                    <template #default="{valueData}">
                        <div class="card-box" style="background: #EFF4FF">
                            <p class="card-label">提现至</p>
                            <div class="card flex-center" style="background: #EFF4FF">
                                <div class="card-icon flex-center"><i class="tf">&#xe6a4;</i></div>
                                <p v-if="!valueData[0]" class="flex-grow" style="color: #f55;">请选择银行卡</p>
                                <p v-else class="flex-grow">{{valueData[0].data.bank_name}} ({{valueData[0].data.bank_card_no}})</p>
                                <i class="tf" style="color: var(--color-main)">&#xe6af;</i>
                            </div>
                        </div>
                    </template>
                    <template #option="{data}">
                        <div class="card card-option flex-center">
                            <div class="card-icon flex-center"><i class="tf">&#xe6a4;</i></div>
                            <p class="flex-grow">{{data.data.bank_name}} ({{data.data.bank_card_no}})</p>
                        </div>
                    </template>
                </c-select>
            </c-form-item>
            <c-form-item label="提现金额" required :tip="'每次提现将收取1元手续费，单次提现最多5万元'">
                <c-input name="withdraw_amount" class="m-price-input" type="number" decimal="2" :range="[1, Math.min(this.balance, 50000)]"
                         :placeholder="'此次提现最多可提现'+balance+'元'" append-text="元" :disabled="withdraw_time_disabled"></c-input>
            </c-form-item>
            <c-form-item label="验证码" required :tip="phone?'验证码将发送至手机 '+phone+'，请注意查收':''">
                <c-input class="flex-grow" type="text" name="verify_code" v-model="verify_code" maxlength="6" :clear="false"
                         :disabled="withdraw_time_disabled">
                    <template #append>
                        <a class="smscode" :class="{'z-dis': !!countdown || withdraw_time_disabled}" @click="getSmscode">{{countdownText}}</a>
                    </template>
                </c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";
import withdrawTimeMixin from '@/mixins/withdraw_time';

export default {
    name: 'accountWithdraw',
    mixins: [withdrawTimeMixin],
    props: {
        withdraw_account_type: [String, Number]
    },
    watch: {
    },
    data() {
        return {
            phone: '',
            verify_code: '',
            countdown: false,
            balance:0,   //通联余额
            min_withdraw_amount:1,
            max_withdraw_amount:50000
        }
    },
    mounted() {
        this.countdown = false;
    },
    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo']),
        countdownText() {
            return this.countdown ? `(${this.countdown})` : this.countdown === 0 ? '重新获取' : '获取验证码';
        }
    },

    methods: {
        /************打开新增、编辑弹窗，数据初始化**************/
        open() {
            this.$refs.form.clear();
            this.getAccountDetail();
            this.$refs.dialog.open({
                title: '【通联账户】提现申请'
            });
        },
        //获取验证码
        getSmscode() {
            if (this.countdown) return;
            //非提现时段：链接已置灰，此处再拦一次，避免任何途径发出短信
            if (this.withdraw_time_disabled) {
                this.$message({message: this.withdraw_time_tip});
                return;
            }
            //调用发送短信接口
            this.request({
                url: '/saas_withdraw/verify/code',
                data: {},
                loading: true,
                success: data => {
                    this.phone = data;
                    this.$message({
                        message: '验证码已发送'
                    });
                    //60秒后可以重新获取
                    !function loop(s) {
                        this.countdown = s;
                        if (s == 0) return;
                        this._timer = setTimeout(() => {
                            loop.call(this, --s);
                        }, 1000);
                    }.call(this, 60);
                }
            });
        },

        /****************查询账户余额***************************/
        getAccountDetail() {
            this.request({
                url: '/sys_saas/account/info',
                data: {
                },
                success: data => {
                    this.balance = data.withdrawable_balance||0;
                    if (this.balance < this.max_withdraw_amount){
                        this.max_withdraw_amount = this.balance;
                    }
                }
            })
        },

        /*******搜索已绑定银行卡*****************/
        searchBankCard(keyword, resolve) {
            this.request({
                url: '/sys_saas/bankcard/options',
                data: {
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },

        /*******创建、编辑提交处理方法********/
        editHandle (stop, next){
            stop();
            //非提现时段：底部按钮已样式置灰，此处再拦一次，避免提交到后端后才在通联侧失败
            if (this.withdraw_time_disabled) {
                this.$message({message: this.withdraw_time_tip});
                return;
            }
            this.$refs.form.submit({
                url: '/withdraw/saas/apply',
                rule: {
                    withdraw_amount: [{
                        type: 'empty',
                        message: '请输入提现金额'
                    }, {
                        type: 'function',
                        fun: (value, data) => {
                            return value <= this.balance;
                        },
                        message: '提现金额不能超过通联账户余额：￥'+this.balance+'元'
                    }],
                    verify_code: '请输入提现验证码',
                    bank_card_id: '请选择提现银行卡'
                },
                dataFormatter: data => {
                    data.withdraw_account_type = this.withdraw_account_type
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: '提现申请成功',  // 提示内容,
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
//非可提现时段的提示条（置于 c-form 内以继承其内边距，宽度占满单列）
.m-withdraw-time-tip {
    box-sizing: border-box;
    width: 100%;
    margin: 0 0 6px;
    padding: 8px 12px;
    font-size: 14px;
    line-height: 18px;
    color: #f55;
    background: rgba(250, 140, 22, 0.08);
    border-radius: 4px;
}

//自研 c-dialog 的底部按钮不支持 disabled 属性，样式层统一置灰并阻断点击
.z-time-disabled {
    >>> .c-dialog-foot {
        opacity: .4;
        pointer-events: none;
    }
}

//银行卡选择卡片的底色为硬编码值，disabled 不会自动变灰，补一层降透明度
.z-time-disabled .card-box {
    opacity: .5;
}

.smscode {
    display: block;
    margin-top: 9px;
    margin-right: 8px;
    line-height: 20px;
    font-size: 12px;
    color: var(--color-main);

    &.z-dis {
        color: #999;
    }
}
.import-steps {
    padding: 10px 20px;
    background-color: #F8F8F8;

    h5 {
        line-height: 36px;
        font-size: 15px;
    }

    p {
        padding: 4px 0;
        line-height: 20px;
        color: #666;
    }
}

.import-explain {
    padding: 20px;

    >>> p {
        padding: 4px 0;
        line-height: 20px;
    }
}

.import-fruit {
    height: 200px;
    background-color: #F8F8F8;

    h1 {
        margin-bottom: 30px;
        font-size: 26px;
    }
}

.card {
    gap: 12px;
    height: 50px;
    padding: 0 14px;
    font-size: 16px;

    &-box {
        border-radius: 6px;
        padding: 12px 0 6px;
        cursor: pointer;
    }

    &-label {
        padding: 0 14px;
        margin-bottom: 4px;
        font-size: 14px;
        color: #666;
    }

    &-option {
        &:hover {
            background: #F5F5F5;
        }
    }

    &-icon {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        font-size: 20px;
        color: #fff;
        background: var(--color-main);
    }
}
</style>